// src/components/navbar/mobileNav/mobileMenuData.js
//
// Espejo del menú desktop (components/megamenu/megaMenuData.js) con el diseño
// mobile: la primera columna de cada sección va como links directos, el resto
// como acordeones, y los productos destacados como carruseles con foto.
// Si cambias algo en el desktop, refléjalo aquí.

// Thumbnails reales servidos desde R2 (Cloudflare) por handle.
const R2 = 'https://pub-af8345b2339e47c4a9067290386af123.r2.dev';

export const mobileMenuData = {
  // Secciones principales del menú (mismo orden que desktop)
  mainSections: [
    // ============================================
    // 1. ARRIVALS
    // ============================================
    {
      id: 'novedades',
      label: 'Arrivals',
      hasSubmenu: true,
      submenu: {
        title: 'Arrivals',
        featuredSection: {
          title: 'Nuevos lanzamientos',
          subtitle: 'Descubre lo nuevo',
          products: [
            {
              id: 'arr-1',
              name: 'Antioxidante Serum Vitamina C',
              image: `${R2}/vitamina_12_Serum_luminosidad_physiology_skincare_12%25-01KWV2NHKDD8YNKY1CVE8DJ00X.webp`,
              url: '/products/serum-vitamina-c-pura-12-20'
            },
            {
              id: 'arr-2',
              name: 'Restorative Hydra Cream',
              image: `${R2}/Hydra_Cream_crema_Ultrahidratante_Front_100_Ml-01KW8TDEHHMC3QAAN5ZV5YXA3Y.webp`,
              url: '/products/restorative-hydra-cream'
            },
            {
              id: 'arr-3',
              name: 'The Journey Kit',
              image: `${R2}/Kit_physiology_viaje_eaurora_I-01KXKQ89ZHE8E1H5WA7JP1Q5XH.webp`,
              url: '/products/the-journey-kit'
            },
            {
              id: 'arr-4',
              name: 'Triada Anti Manchas',
              image: '/images/products/Triada_antimanchas_serums_physiology_skincare.webp',
              url: '/products/triada-anti-manchas'
            }
          ]
        },
        secondarySection: {
          title: 'Productos destacados',
          products: [
            {
              id: 'arr-5',
              name: 'Kit Minimalista',
              image: `${R2}/Kit_minimalista_physiology_skincare_2-01KXKVXS0Q41X4QTS8Q1RACA3V.webp`,
              url: '/products/kit-minimalista-basico'
            },
            {
              id: 'arr-6',
              name: 'Tónico Centella Asiática',
              image: `${R2}/Tonico_de_Centella_Asiatica_120ml-01KWNW4TK30ES8QCB4RGBJ74TW.webp`,
              url: '/products/tonico-centella-asiatica'
            },
            {
              id: 'arr-7',
              name: 'Aurora — The Journey Kit I',
              image: `${R2}/Kit_physiology_viaje_eaurora_I-01KXKQ89ZHE8E1H5WA7JP1Q5XH.webp`,
              url: '/products/the-journey-kit'
            },
            {
              id: 'arr-8',
              name: 'Ultrabarrier Repair',
              image: '/images/products/ultrabarrier-textura-tienda.webp',
              url: '/products/ultra-barrier-repair-60ml'
            }
          ]
        },
        promo: {
          title: 'Descubre lo nuevo',
          subtitle: 'Limpiador a Miel — últimos lanzamientos',
          image: '/images/secciones/menu-mobile/Seccion_menu_mobile_arrivals.webp',
          url: '/products/limpiador-a-la-miel'
        }
      }
    },

    // ============================================
    // 2. CATÁLOGO
    // ============================================
    {
      id: 'rostro',
      label: 'Catálogo',
      hasSubmenu: true,
      submenu: {
        title: 'Catálogo',
        links: [
          { label: 'Todo skincare', url: '/shop' },
          { label: 'Limpiadores', url: '/shop?category=limpiadores' },
          { label: 'Exfoliantes', url: '/shop?category=exfoliantes' },
          { label: 'Tónicos y Esencias', url: '/shop?category=tonicos' },
          { label: 'Sueros', url: '/shop?category=sueros' },
          { label: 'Correctivos', url: '/shop?category=correctivos' },
          { label: 'Tratamientos', url: '/shop?category=tratamientos' },
          { label: 'Hidratantes', url: '/shop?category=hidratantes' },
          { label: 'Nuestra selección', url: '/curated-selection' }
        ],
        accordions: [
          {
            id: 'tipo-piel',
            title: 'Tipo de piel',
            links: [
              { label: 'Normal', url: '/shop?skin=Normal' },
              { label: 'Seca', url: '/shop?skin=Seca' },
              { label: 'Grasa', url: '/shop?skin=Grasa' },
              { label: 'Mixta', url: '/shop?skin=Mixta' },
              { label: 'Sensible', url: '/shop?skin=Sensible' }
            ]
          },
          {
            id: 'preocupacion',
            title: 'Preocupación de la piel',
            links: [
              { label: 'Acné', url: '/shop?concern=Acn%C3%A9' },
              { label: 'Manchas', url: '/shop?concern=Manchas' },
              { label: 'Arrugas', url: '/shop?concern=Arrugas' },
              { label: 'Poros dilatados', url: '/shop?concern=Poros+dilatados' },
              { label: 'Luminosidad', url: '/shop?concern=Luminosidad' },
              { label: 'Hidratación', url: '/shop?concern=Hidrataci%C3%B3n' }
            ]
          },
          {
            id: 'nuevas-adiciones',
            title: 'Nuevas adiciones',
            links: [
              { label: 'RESURGE Advance Phase I', url: '/products/resurge-advance-phase-i-serum' },
              { label: 'RESURGE TONIC Phase II', url: '/products/resurge-tonic-phase-2' },
              { label: 'SOMA Lacta Phase I', url: '/products/soma-lacta-phase-i-serum' }
            ]
          }
        ],
        promo: {
          title: 'Explora todo',
          subtitle: 'Nuestro catálogo completo',
          image: '/images/secciones/menu-mobile/Seccion_catalogo_explorar_todo.webp',
          url: '/shop'
        }
      }
    },

    // ============================================
    // 3. COMPENDIO
    // ============================================
    {
      id: 'cuerpo',
      label: 'Compendio',
      hasSubmenu: true,
      submenu: {
        title: 'Compendio',
        // Sin páginas todavía (en desktop son '#').
        links: [
          { label: 'Limpiadores corporales', url: '/en-construccion' },
          { label: 'Exfoliantes', url: '/en-construccion' },
          { label: 'Hidratantes', url: '/en-construccion' },
          { label: 'Cuidado de manos', url: '/en-construccion' },
          { label: 'Cuidado personal', url: '/en-construccion' },
          { label: 'Protección solar', url: '/en-construccion' },
          { label: 'Ver todo Mano y cuerpo', url: '/en-construccion' }
        ],
        featuredSection: {
          title: 'Destacados',
          products: [
            {
              id: 'comp-1',
              name: 'Restorative Hydra Cream',
              image: `${R2}/Hydra_Cream_crema_Ultrahidratante_Front_100_Ml-01KW8TDEHHMC3QAAN5ZV5YXA3Y.webp`,
              url: '/products/restorative-hydra-cream'
            },
            {
              id: 'comp-2',
              name: 'Tónico Centella Asiática',
              image: `${R2}/Tonico_de_Centella_Asiatica_120ml-01KWNW4TK30ES8QCB4RGBJ74TW.webp`,
              url: '/products/tonico-centella-asiatica'
            },
            {
              id: 'comp-3',
              name: 'Kit Minimalista (travel)',
              image: `${R2}/Kit_minimalista_physiology_skincare_2-01KXKVXS0Q41X4QTS8Q1RACA3V.webp`,
              url: '/products/kit-minimalista-basico'
            }
          ]
        },
        promo: {
          title: 'Guías y recursos',
          subtitle: 'Aprende más sobre skincare',
          image: '/images/secciones/menu-mobile/Seccion_mobile_compendio.webp',
          url: '/journal'
        }
      }
    },

    // ============================================
    // 4. MANIFIESTO
    // ============================================
    {
      id: 'hogar',
      label: 'Manifiesto',
      hasSubmenu: true,
      submenu: {
        title: 'Manifiesto',
        links: [
          { label: 'Nuestra historia', url: '/nuestra-historia' },
          { label: 'Filosofía', url: '/filosofia' },
          { label: 'Ingredientes', url: '/ingredientes' },
          { label: 'Sostenibilidad', url: '/sostenibilidad' },
          { label: 'Prensa', url: '/en-construccion' }
        ],
        accordions: [
          {
            id: 'comunidad',
            title: 'Comunidad',
            links: [
              { label: 'Eventos', url: '/en-construccion' },
              { label: 'Colaboraciones', url: '/en-construccion' },
              { label: 'Embajadores', url: '/en-construccion' }
            ]
          }
        ],
        promo: {
          title: 'Nuestra filosofía',
          subtitle: 'Conoce más sobre Physiology',
          image: '/images/megamenu/manifesto-default.webp',
          url: '/filosofia'
        }
      }
    },

    // ============================================
    // 5. KITS DE VIAJE
    // ============================================
    {
      id: 'fragancias',
      label: 'Kits de viaje',
      hasSubmenu: true,
      submenu: {
        title: 'Kits de viaje',
        featuredSection: {
          title: 'Descubrir Kits',
          subtitle: 'Viaja con estilo',
          products: [
            {
              id: 'kit-1',
              name: 'Aurora — The Journey Kit I',
              image: `${R2}/Kit_physiology_viaje_eaurora_I-01KXKQ89ZHE8E1H5WA7JP1Q5XH.webp`,
              url: '/products/the-journey-kit'
            },
            {
              id: 'kit-2',
              name: 'Odyssey — The Journey Kit II',
              image: `${R2}/Kit_de_viaje_the_odissey_physiology_portada-01KXKBJ2D1C3RPHS6R3PMJZYM5.webp`,
              url: '/products/the-journey-kit-ii'
            },
            {
              id: 'kit-3',
              name: 'Eclipse — The Journey Kit III',
              image: `${R2}/Kit_physiology_viaje_eclipse_III-01KXKND6YQRZP59RWX2ETPG46X.webp`,
              url: '/products/the-journey-kit-iii'
            },
            {
              id: 'kit-4',
              name: 'Kit Minimalista',
              image: `${R2}/Kit_minimalista_physiology_skincare_2-01KXKVXS0Q41X4QTS8Q1RACA3V.webp`,
              url: '/products/kit-minimalista-basico'
            }
          ]
        },
        accordions: [
          {
            id: 'por-necesidad',
            title: 'Por necesidad',
            // En desktop son etiquetas sin link.
            links: [
              { label: 'Hidratación' },
              { label: 'Anti-edad' },
              { label: 'Luminosidad' }
            ]
          }
        ],
        promo: {
          title: 'Viaja con estilo',
          subtitle: 'Kits perfectos para llevar',
          image: '/images/megamenu/travel-kits-default.webp',
          url: '/products/the-journey-kit'
        }
      }
    },

    // ============================================
    // 6. AFILIADOS — "Encuentra un afiliado" abre el mapa (StoreLocator)
    // ============================================
    {
      id: 'regalos',
      label: 'Afiliados',
      hasSubmenu: true,
      submenu: {
        title: 'Afiliados',
        links: [
          { label: 'Encuentra un afiliado', action: 'store-locator' },
          { label: 'Únete como socia', url: '/socios-y-distribuidores' }
        ]
      }
    },

    // ============================================
    // 7. ARCHIVO — Blog (los posts reales vienen del backend vía BlogContext)
    // ============================================
    {
      id: 'citas',
      label: 'Archivo',
      hasSubmenu: true,
      submenu: {
        title: 'Archivo',
        description: 'The Asurbanipal — artículos y guías de skincare',
        categories: [
          { label: 'Ver todos los artículos', url: '/journal' }
        ],
        // Fallback si todavía no hay artículos publicados.
        blogPosts: [],
        promo: {
          title: 'Lee más',
          subtitle: 'Artículos y guías',
          image: '/images/secciones/menu-mobile/Seccion_mobile_blog.webp',
          url: '/journal'
        }
      }
    },

    // ============================================
    // LINK SIMPLE — Socios
    // ============================================
    {
      id: 'leer',
      label: 'Socios',
      hasSubmenu: false,
      url: '/socio',
      // Socia (o sin sesión) → /socio. Cliente con sesión → aviso sobre el menú.
      action: 'socios'
    }
  ],

  // Links secundarios (abajo del menú principal). El de cuenta se agrega
  // dinámicamente en el componente.
  secondaryLinks: [
    { label: 'Favoritos', url: '/wishlist' },
    { label: 'Asistencia', url: '/contacto' },
    { label: 'Lectura', url: '/journal' }
  ]
};

export default mobileMenuData;
